<script lang="ts">
  import { getContext } from "svelte";
  import Navigation from "./side/Navigation.svelte";
  import PoiDetail from "./side/PoiDetail.svelte";
  import { ConnectMapApp } from "./app";

  const app = getContext<ConnectMapApp<any>>('app');
  const { state } = app;

</script>

<div class="bottom-pane">
  {#if $state == 'detail_view'}
    <PoiDetail />
  {:else if $state == 'navigation_view'}
    <Navigation />
  {/if}
</div>

<style>
  .bottom-pane {
    width: 100%;
    padding: 0 0 var(--_p1);
    background-color: var(--_bg-1st);
  }
</style>
